import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SfaDealWorklogContainerModel } from "../../../../../../models/aggregates/sfa/deal/SfaDealWorklogContainer.model";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";

@Injectable({
    providedIn: 'root'
    })
    export class SfaDealWorklogService extends BaseApiTemplateService<SfaDealWorklogContainerModel> {

    readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'deal-worklogs';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'deal-worklogs';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'deal-worklogs';
        this.httpClient = http;
    }
    }